import styled from 'styled-components';
import H7 from 'UIComponents/elements/headings/H7';
import { FLINT } from 'HubStyleTokens/colors';
// @ts-expect-error untyped import
import PlainLink from '../../../PlainLink';
import ReducedCardThumbnailSection from './ReducedCardThumbnailSection';
import ReducedCardWrapper from './ReducedCardWrapper';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIIcon from 'UIComponents/icon/UIIcon';
import { useState } from 'react';
import AccordionTransition from 'UIComponents/transitions/AccordionTransition';
import { device } from '../../../../constants/StyledComponentConstants';
import UITruncateString from 'UIComponents/text/UITruncateString';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ReducedCardContentBox = styled.div.withConfig({
  displayName: "ReducedCardLayout__ReducedCardContentBox",
  componentId: "sc-12ay0tk-0"
})(["padding:0 16px;flex:1;"]);
const CardWrapper = styled.div.withConfig({
  displayName: "ReducedCardLayout__CardWrapper",
  componentId: "sc-12ay0tk-1"
})(["padding:0;"]);
const Spacer = styled.div.withConfig({
  displayName: "ReducedCardLayout__Spacer",
  componentId: "sc-12ay0tk-2"
})(["&:not(:last-child){", "}"], props => props.verticalGap && `margin-bottom: ${props.verticalGap}px;`);
const ReadMoreBox = styled.div.withConfig({
  displayName: "ReducedCardLayout__ReadMoreBox",
  componentId: "sc-12ay0tk-3"
})(["display:flex;justify-content:flex-end;align-items:center;white-space:nowrap;.read-more-text{@media screen and ", "{display:none;}}"], device.mobile);
export const ReducedCardHeading = styled(H7).withConfig({
  displayName: "ReducedCardLayout__ReducedCardHeading",
  componentId: "sc-12ay0tk-4"
})(["font-weight:500;", ""], ({
  size
}) => size === 'medium' ? 'font-size: 20px; margin-left: -1px ' : '');
const ReducedCardLayout = ({
  deprecated,
  name,
  description,
  to,
  use = 'on-light',
  contentId,
  isCertificateCourse,
  isCompleted,
  progressAmount,
  thumbnailUrl,
  children,
  onClick,
  verticalGap,
  expandableContent,
  isSelected,
  rightAction,
  size = 'small',
  customAction
}) => {
  const WrapperComponent = deprecated || expandableContent ? CardWrapper : PlainLink;
  const [expanded, setExpanded] = useState(false);
  return /*#__PURE__*/_jsxs(Spacer, {
    className: "reduced-card",
    verticalGap: verticalGap,
    children: [/*#__PURE__*/_jsx(WrapperComponent, {
      "aria-controls": `show-more-${contentId}`,
      "aria-expanded": expanded,
      onClick: () => {
        if (onClick) onClick();
        if (expandableContent) setExpanded(bool => !bool);
      },
      role: expandableContent ? 'button' : 'link',
      to: to,
      children: /*#__PURE__*/_jsxs(ReducedCardWrapper, {
        className: isSelected ? 'isSelected' : undefined,
        "data-test-id": 'reduced-card',
        "data-test-is-certification": isCertificateCourse,
        "data-test-is-selected": isSelected,
        "data-test-meta": contentId,
        use: use,
        children: [/*#__PURE__*/_jsx(ReducedCardThumbnailSection, {
          altText: name,
          customAction: customAction,
          deprecated: deprecated,
          isCompleted: isCompleted,
          progressAmount: progressAmount,
          size: size,
          thumbnailUrl: thumbnailUrl,
          use: use
        }), /*#__PURE__*/_jsxs(ReducedCardContentBox, {
          children: [/*#__PURE__*/_jsx(ReducedCardHeading, {
            className: size === 'medium' ? 'm-bottom-1' : 'm-bottom-0',
            size: size,
            style: {
              color: deprecated ? FLINT : 'inherit'
            },
            children: name
          }), size === 'medium' && /*#__PURE__*/_jsx(UITruncateString, {
            tooltip: null,
            children: description
          }), children]
        }), rightAction && /*#__PURE__*/_jsx("div", {
          children: rightAction
        }), expandableContent && /*#__PURE__*/_jsxs(ReadMoreBox, {
          children: [/*#__PURE__*/_jsx(UIIcon, {
            name: expanded ? 'up' : 'down',
            style: {
              position: 'relative',
              top: '1px'
            }
          }), /*#__PURE__*/_jsx(H7, {
            className: "read-more-text m-bottom-0 m-left-2",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: `academyComponents.reducedContentCards.${expanded ? 'readLess' : 'readMore'}`
            })
          })]
        })]
      })
    }), /*#__PURE__*/_jsx(AccordionTransition, {
      "data-test-id": "expandable-content",
      "data-test-meta": contentId,
      id: `show-more-${contentId}`,
      open: expanded,
      children: expandableContent
    })]
  });
};
export default ReducedCardLayout;